import { css } from '@linaria/core';
import type { FontColorType } from './font-styles';

const primary = css`
  color: var(--fabric-color-icon-primary);
`;

const defaultColor = css`
  color: var(--fabric-color-text-primary);
`;

const subdued = css`
  color: var(--fabric-color-text-muted);
`;

const light = css`
  color: var(--fabric-color-text-secondary);
`;

const disabled = css`
  color: var(--fabric-color-text-disabled);
`;

const white = css`
  color: var(--fabric-color-text-on-inverted);
`;

const error = css`
  color: var(--fabric-color-status-error-default);
`;

const success = css`
  color: var(--fabric-color-status-success-default);
`;

const warn = css`
  color: var(--fabric-color-status-warning-default);
`;

const inherited = css`
  color: inherit;
`;

const FONT_COLOR_CLASS: Record<FontColorType, string> = {
  primary,
  default: defaultColor,
  subdued,
  light,
  disabled,
  white,
  error,
  success,
  warn,
  inherit: inherited,
};

export const getFontColorClassName = (color: FontColorType) => FONT_COLOR_CLASS[color] ?? FONT_COLOR_CLASS.default;
